export default __webpack_public_path__ + "static/media/girl-granola-honey-blue-white-natural.d2031cbf.jpg";